import { useEffect, useState } from "react";
import { CreditCard, Globe, Image as ImageIcon, Inbox, Package } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminDashboard({ onNavigate }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/admin/enquiries", { params: { status: "New" } }).then((r) => r.data.length).catch(() => 0),
      api.get("/admin/products").then((r) => r.data.length).catch(() => 0),
      api.get("/admin/orders", { params: { status: "Paid" } }).then((r) => r.data.length).catch(() => 0),
      api.get("/admin/media").then((r) => r.data.length).catch(() => 0),
    ]).then(([enquiries, products, orders, media]) =>
      setStats({ enquiries, products, orders, media }),
    );
  }, []);

  const cards = [
    { label: "New Enquiries", value: stats?.enquiries, icon: Inbox, tab: "enquiries", testid: "stat-enquiries" },
    { label: "Products", value: stats?.products, icon: Package, tab: "products", testid: "stat-products" },
    { label: "Paid Orders", value: stats?.orders, icon: CreditCard, tab: "orders", testid: "stat-orders" },
    { label: "Media Files", value: stats?.media, icon: ImageIcon, tab: "media", testid: "stat-media" },
  ];

  return (
    <section data-testid="admin-home">
      <h2 className="mb-2 font-serif text-3xl font-medium">Welcome back</h2>
      <p className="mb-8 text-sm text-[#5C5C5C]">
        Manage your website content, products, orders and enquiries from here — no coding needed.
      </p>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {cards.map((c) => (
          <button
            key={c.label}
            data-testid={c.testid}
            onClick={() => onNavigate(c.tab)}
            className="group rounded-2xl border border-line bg-white p-5 text-left transition-shadow hover:shadow-lg hover:shadow-rose/10"
          >
            <c.icon size={18} className="text-rose" />
            <p className="mt-3 font-serif text-3xl font-semibold">{c.value ?? "…"}</p>
            <p className="mt-1 text-xs uppercase tracking-[0.15em] text-[#5C5C5C]">{c.label}</p>
          </button>
        ))}
      </div>
      <button
        data-testid="dashboard-edit-website"
        onClick={() => onNavigate("website")}
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-medium text-cream transition-colors hover:bg-rose hover:text-white"
      >
        <Globe size={15} /> Edit Website Content
      </button>
    </section>
  );
}
